export default "__VITE_ASSET__e43374b3__"